<template>
  <div class="bottom-modal__wrap">
    <div class="bottom-modal__content account-share">
      <div
        class="account-box"
        v-for="account in obituaryMembersAccount"
        :key="account.memberBankNumber"
        :class="{
          active: selectAccount.id === account.id
        }"
        @click="selectAccount = account"
      >
        <div class="account-info__wrap">
          <h4>예금주명</h4>
          <span>{{ account.bankHolder }}</span>
        </div>
        <div class="account-info__wrap">
          <h4>은행명</h4>
          <span>{{ bankTxt(account.memberBank) }}</span>
        </div>
        <div class="account-info__wrap">
          <div class="account-info-title__wrap">
            <h4>계좌번호</h4>
            <button @click="handleCopy(account)">복사</button>
          </div>
          <span> {{ account.memberBankNumber }} </span>
        </div>
      </div>
    </div>
    <div class="bottom-modal-icon__wrap account-share">
      <SnsIcon
        :class="{ active: snsType === 'kakao' }"
        :image="require('@/assets/icons/obituary/kakao.svg')"
        title="카톡"
        @shareSns="snsType = 'kakao'"
      />
      <SnsIcon
        :class="{ active: snsType === 'sms' }"
        :image="require('@/assets/icons/obituary/sms.svg')"
        title="문자"
        @shareSns="snsType = 'sms'"
      />

      <SnsIcon
        :class="{ active: snsType === 'band' }"
        :image="require('@/assets/icons/obituary/band.svg')"
        title="밴드"
        @shareSns="snsType = 'band'"
      />
    </div>
    <div class="bottom-modal-button__wrap">
      <div class="bottom-modal-button close" @click="close">닫기</div>
      <div class="bottom-modal-button apply" @click="handleShare">공유하기</div>
    </div>

    <a ref="sms" :href="smsHref"></a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import myMixin from "@/mixin/mixin";

import SnsIcon from "./SnsIcon.vue";
export default {
  components: { SnsIcon },
  name: "AccountListModal",
  props: ["accountViewFlag"],
  mixins: [myMixin],

  data() {
    return {
      selectAccount: {},
      snsType: "kakao",

      memberId: this.$route.query.memberId ? this.$route.query.memberId : null,
      bankOnly: this.$route.query.bankOnly ? this.$route.query.bankOnly : null,

      currentUrl: ""
    };
  },

  computed: {
    ...mapGetters(["getObituary"]),

    obituaryMembersAccount() {
      const obituaryMembers = this.getObituary?.ObituaryMembers || [];
      // ObituaryMembers 데이터를 가져오는 함수
      const getFilteredMembers = filterCondition => {
        return (
          obituaryMembers?.length > 0 &&
          obituaryMembers?.filter(filterCondition)
        );
      };

      // 현재 부고 구성원 찾기
      const currentObituaryMembers = getFilteredMembers(
        v => v.id === +this.memberId
      );

      // 동기화된 부고 구성원 필터링
      let syncObituaryMembers = getFilteredMembers(
        v => v.memberBankNumber && v.syncFlag
      );

      //  중복 은행들을 제거한다.
      const uniqueBanks = new Set();
      syncObituaryMembers = syncObituaryMembers.filter(user => {
        const key = `${user.memberBank}-${user.memberBankNumber}`;
        if (uniqueBanks.has(key)) {
          return false;
        } else {
          uniqueBanks.add(key);
          return true;
        }
      });

      // 조건에 따라 결과 반환
      let membersToReturn;
      if (
        this.bankOnly === "Y" ||
        currentObituaryMembers[0]?.accountViewType == 0
      ) {
        membersToReturn = currentObituaryMembers;
      } else if (
        this.bankOnly === "N" ||
        currentObituaryMembers[0]?.accountViewType == 1
      ) {
        membersToReturn = syncObituaryMembers;
      } else if (this.memberId) {
        membersToReturn = currentObituaryMembers;
      } else {
        membersToReturn = syncObituaryMembers;
      }

      const memberSortNum = {
        상주: 1,
        배우자: 2,
        아들: 3,
        딸: 4,
        며느리: 5,
        사위: 6,
        손: 7,
        손자: 8,
        손녀: 9,
        외손: 10,
        외손자: 11,
        외손녀: 12,
        기타: 13,
      };

      return membersToReturn.sort((a, b) => {
        const aType = a.memberType.replace(/\s+/g, ''); // 공백 제거
        const bType = b.memberType.replace(/\s+/g, ''); // 공백 제거

        return (memberSortNum[aType] || 99) - (memberSortNum[bType] || 99);
      });
    },

    smsMessage() {
      return `[상주 ${this.selectAccount.memberName}님의 조의금 계좌]

예금주: ${this.selectAccount.bankHolder}
${this.bankTxt(this.selectAccount.memberBank)} ${
        this.selectAccount.memberBankNumber
      }
`;
    },

    kakaoBody() {
      const smsMessage = this.smsMessage;

      let realSmsMessage = smsMessage.replace(/(\n|\r\n)/g, "%0a");
      realSmsMessage = smsMessage;

      return realSmsMessage;
    },

    smsBody() {
      const smsMessage = this.smsMessage;

      let realSmsMessage = smsMessage.replace(/(\n|\r\n)/g, "%0a");
      realSmsMessage = smsMessage;

      return encodeURIComponent(realSmsMessage);
    },

    checkMobile() {
      var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

      if (varUA.indexOf("android") > -1) {
        //안드로이드
        return "android";
      } else if (
        varUA.indexOf("iphone") > -1 ||
        varUA.indexOf("ipad") > -1 ||
        varUA.indexOf("ipod") > -1 ||
        varUA.indexOf("mac") > -1
      ) {
        //IOS
        return "ios";
      } else {
        //아이폰, 안드로이드 외
        return "other";
      }
    },

    smsHref() {
      return (
        "sms:" +
        (this.checkMobile === "ios" ? "&" : "?") +
        "body=" +
        this.smsBody
      );
    }
  },

  mounted() {
    this.selectAccount = this.obituaryMembersAccount[0];
    this.currentUrl = window.location.href;
  },

  methods: {
    close() {
      this.$emit("close");
    },

    sendLinkKakao() {
      this.$kakao.Link.sendDefault({
        objectType: "text",
        text: this.kakaoBody,
        link: {
          mobileWebUrl: this.currentUrl,
          webUrl: this.currentUrl
        }
      });
    },
    shareNaverBand() {
      const content = this.smsBody;
      const link = `http://band.us/plugin/share?body=${content}`;

      window.open(link, "share", "width=500, height=500");
    },
    async handleCopy(account) {
      const textToCopy = `${account.bankHolder} ${this.bankTxt(
        account.memberBank
      )} ${account.memberBankNumber}`;

      try {
        await navigator.clipboard.writeText(textToCopy);
        alert("클립보드에 복사되었습니다.");
      } catch (err) {
        if (!document.queryCommandSupported("copy")) {
          return alert("복사하기가 지원되지 않는 브라우저입니다.");
        }

        const textarea = document.createElement("textarea");
        textarea.value = textToCopy;
        textarea.style.top = 0;
        textarea.style.left = 0;
        textarea.style.position = "fixed";

        document.body.appendChild(textarea);

        textarea.focus();
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("클립보드에 복사되었습니다.");
      }
    },

    handleShare() {
      switch (this.snsType) {
        case "kakao":
          this.sendLinkKakao();
          break;

        case "sms":
          this.$refs.sms.click();
          break;

        case "band":
          this.shareNaverBand();
          break;

        default:
          break;
      }

      this.close();
    }
  }
};
</script>

<style></style>
